module.exports = __webpack_public_path__ + "img/mf.1abc9ffc.svg";